module.exports = __webpack_public_path__ + "img/global-search-icon-new.6a3a5cd7.svg";